module.exports = __webpack_public_path__ + "img/20191015164957360截图20191015155347108.c7baa9ec.jpg";